import { VehicleSpecEffect } from '../../VehicleSpec.types'
import './FullVehicleSpecItem.css'

export interface FullVehicleSpecItemField {
	name: string,
	value: number,
	baseValue: string | number,
	value_sign: string,
	effects: VehicleSpecEffect[]
	description: string
}

export interface FullVehicleSpecItemProps {
	icon: string,
	title: string,
	fields: FullVehicleSpecItemField[],
	onHover: (event: React.MouseEvent, field: FullVehicleSpecItemField) => void,
	onLeave: () => void
}

export const FullVehicleSpecItem = ({
	icon,
	title,
	fields,
	onHover,
	onLeave
}: FullVehicleSpecItemProps) => {

	const getActualValue = (value: any) => {
		if (!value) return -1
		if (typeof value === 'string') return value
		return Math.abs(value) < 10 ? value.toFixed(2) : value.toFixed(0)
	}

	return (<>

		<div className='full-vehicle-spec-item'>

			<div className='full-vehicle-spec-item-title'>
				<img className='full-vehicle-spec-item-title-icon' src={`./icons/32px/${icon}.webp`}></img>
				<p>{title}</p>
			</div>

			<div className='full-vehicle-spec-item-fields'>
				{fields.map((field) => (
					<div
						className='full-vehicle-spec-item-field'
						key={field.name}
						onMouseEnter={(event) => onHover(event, field)}
						onMouseMove={(event) => onHover(event, field)}
						onMouseLeave={onLeave}
					>
						<p className='full-vehicle-spec-item-field-name'>{field.name}</p>
						<p className='full-vehicle-spec-item-field-value'>{`${getActualValue(field.value)} ${field.value_sign}`}</p>
					</div>
				))}
			</div>

		</div>


	</>)

}